import { useCallback } from 'react'

import { apiUrl, useApiRequest } from '../useApiRequest'

import { CourtDeactivation } from '../../types/booking/booking'

/**
 * Deactivates a court, keeping or cancelling its future bookings. History is preserved.
 */
export function useDeactivateCourt() {
  const { run, loading, error, resetState } = useApiRequest()

  const deactivate = useCallback(
    (courtId: number, futureBookings: CourtDeactivation['futureBookings']) =>
      run(({ poster }) =>
        poster<void>(apiUrl(`/courts/${courtId}/deactivate`), { futureBookings }, 'application/json')
      ),
    [run]
  )

  return { deactivate, loading, error, resetState }
}
